const tripReports = {
  tripsPaxReports: {
    tripId: 'ID de expedición',
    date: 'Fecha',
    status: 'Estado',
    statuses: 'Estados',
    drivers: 'Conductores',
    vehicles: 'Vehículos',
    from: 'De',
    to: 'Hacia',
    passengers: 'Pasajeros',
    statusDone: 'Listo',
    statusNew: 'Nuevo',
    statusCanceled: 'Cancelado',
    statusInRoute: 'En ruta',
    average: 'Promedio',
    trips: 'Viajes',
    tripsPassengersSummary: 'Resumen de Viajes / Pasajeros',
  },
};

export default tripReports;
